import { render, staticRenderFns } from "./CompCardArticlesFeatured.vue?vue&type=template&id=46f2d1d7"
import script from "./CompCardArticlesFeatured.vue?vue&type=script&setup=true&lang=js"
export * from "./CompCardArticlesFeatured.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports